export default function normalize(data = {}) {
    return {
        adultsCount: data.adultCount || 0,
        childrenCount: data.childCount || 0,
        childAges: data.childAge || [],
    };
}
